import { ErrorInfo } from 'react';

import { isDevMode } from 'lib/isDevMode';

import { DataDog } from '../utils/DataDog';

// Type when following convention
type Context = {
  version: '1';
  errorInfo?: ErrorInfo;
  error?: Error | unknown;
  payload: Record<string, unknown>;
};

export function info(
  domain: string,
  message: string,
  context?: Context
): Promise<void> {
  if (isDevMode()) {
    console.info(`[${domain}] ${message}`, context);
  }
  return DataDog.info(`[${domain}] ${message}`, context);
}
